import * as React from 'react'
import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { TotalAndDescription } from '../../../TotalAndDescription'

import { IOption } from '@user/components/Filters'
import { defaultFilters } from '@user/store/opportunity/filters'
import { dateWithOffset } from '@sales-center/common'

import { useSaveOpportunityFilters } from '@user/store/opportunity/hooks'

interface Props {
  count: number
  days: number
  assignees?: IOption[]
  salesTeams?: IOption[]
  canViewOpps: boolean
}

export const ExpectedClosingDateDue: FC<Props> = (props) => {
  const { count, days, assignees, salesTeams, canViewOpps } = props
  const navigate = useNavigate()

  const saveOpportunityFilters = useSaveOpportunityFilters()

  const callToAction = useCallback(() => {
    const start = new Date()
    const end = dateWithOffset(start, days || 0)

    saveOpportunityFilters({
      ...defaultFilters,
      filters: {
        ...defaultFilters.filters,
        expectedClosingDate: {
          ...defaultFilters.filters.expectedClosingDate,
          value: { matchType: 'bt', start, end },
        },
        salesTeamIds: {
          ...defaultFilters.filters.salesTeamIds,
          value: { mode: 'any', options: salesTeams || [] },
        },
        assignee: {
          ...defaultFilters.filters.assignee,
          value: { mode: 'any', options: assignees || [] },
        },
      },
    })

    navigate('/opportunities')
  }, [assignees, days, navigate, salesTeams, saveOpportunityFilters])

  return (
    <TotalAndDescription
      testIdPrefix="upcoming-follow-ups-expected-closing-date-due"
      callToActionFunction={callToAction}
      callToActionText="Review"
      callToActionAllowed={canViewOpps}
      description={
        <>
          These records have an expected closing date coming due in the next{' '}
          <b>
            {days} {days == 1 ? 'day' : 'days'}
          </b>
          .
        </>
      }
      headerText={
        count == 1
          ? 'Record with Expected Closing Date Due'
          : 'Records with Expected Closing Dates Due'
      }
      total={count}
    />
  )
}

ExpectedClosingDateDue.displayName = 'ExpectedClosingDateDue'
